module.exports = __webpack_public_path__ + "img/adv3.2b87edc3.svg";